import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { showError } from "../utils/showToast";
import { API_BASE_URL } from "../config/api";

export default function BookingPage() {
    const [bookingRef, setBookingRef] = useState("");
    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (!bookingRef.trim()) return;

        setLoading(true);
        try {
            const response = await fetch(`${API_BASE_URL}/api/sale`); // 👈 changed
            const data = await response.json();
            // Convert bookingRef to number for comparison
            const saleIds = data.map((sale: any) => sale.id);
            const enteredId = Number(bookingRef.trim());

            if (saleIds.includes(enteredId)) {
                navigate(`/schedule/${enteredId}`);
            } else {
                showError("Sale ID does not exist. Please enter a valid Sale ID.");
            }
        } catch {
            showError("Unable to verify Sale ID. Please try again later.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-900 to-black px-4">
            <div className="bg-white w-full max-w-xl p-8 rounded-xl shadow-lg">
                <h1 className="text-2xl font-bold text-gray-800 mb-2">
                    Schedule Your <span className="text-blue-600">Care+</span> Service
                </h1>
                <p className="text-gray-600 text-sm mb-6">
                    Let's get started by entering your order number.
                </p>
                <form onSubmit={handleSubmit}>
                    <label
                        htmlFor="bookingRef"
                        className="block text-gray-700 font-medium mb-1"
                    >
                        Order Id
                    </label>
                    <input
                        id="bookingRef"
                        type="text"
                        value={bookingRef}
                        onChange={(e) => setBookingRef(e.target.value)}
                        placeholder="Enter Order ID"
                        className="border rounded px-3 py-2 w-full mb-4 text-gray-900 bg-white"
                        disabled={loading}
                    />
                    <button
                        type="submit"
                        className="bg-blue-600 text-white px-4 py-2 rounded w-full"
                        disabled={loading}
                    >
                        {loading ? "Verifying..." : "Proceed"}
                    </button>
                </form>
            </div>
        </div>
    );
}